import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchWayBridgeChargeDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import CtART from "./CustomTool/ResponsiveTable";

class WayBridgeChargeMaster extends Component {
  state = {
    formData: {
      bint_srno: "",
      txtNoWheels: "",
      txtRate: "",
    },

    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "Sr No.",
      },
      {
        accessorKey: "int_noofwheels",
        header: " No. Wheels",
      },
      {
        accessorKey: "dec_rate",
        header: "Rate",
      },
    ],
    rows: [],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
  };

  componentDidMount() {
    document.title = "RA : Way Bridge Charge";
    this.props.setActiveMenu("WayBridgeChargeMaster");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          maxWidthClass={"xl"}
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  // trimFormData = (nextFunctionCall) => {
  //   let formData = applyTrimOnObjectValues({
  //     formData: this.state.formData,
  //     // excludeKeysArray: [""],
  //     numberKeysArray: [""],

  //   });
  //   this.setState({ formData }, () => {
  //     if (nextFunctionCall) {
  //       nextFunctionCall();
  //     }
  //   });
  // };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadWayBridgeCharge",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchWayBridgeChargeDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (
            res.data.WayBridgeChargeList &&
            res.data.WayBridgeChargeList.length > 0
          ) {
            rows = res.data.WayBridgeChargeList;
            rowsCount = rows.length;
          }
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtNoWheels").focus();
  };

  clearInfo = () => {
    let bint_srno = "",
      txtNoWheels = "",
      txtRate = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txtNoWheels,
          txtRate,
        },
      },
      () => {
        document.getElementById("txtNoWheels").focus();
      }
    );
  };

  validatWayBridgeChargeMaster = () => {
    const { txtNoWheels, txtRate } = this.state.formData;

    if (!txtNoWheels || isNaN(txtNoWheels) || Number(txtNoWheels) <= 0) {
      this.props.toastErrorMsg("Enter a number of wheels.", "txtNoWheels");
      return false;
    }

    if (!txtRate || isNaN(txtRate) || Number(txtRate) <= 0) {
      this.props.toastErrorMsg("Enter a rate.", "txtRate");
      return false;
    }

    return true;
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    const bint_srno = row.getValue("bint_srno"),
      txtNoWheels = row.getValue("int_noofwheels"),
      txtRate = row.getValue("dec_rate");
    // const rows2 = row.original.CheckToDoList;
    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtNoWheels,
        txtRate,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtNoWheels").focus();
  };

  SaveWayBridgeCharge = () => {
    if (this.validatWayBridgeChargeMaster()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "SaveWayBridgeCharge",
          bint_acid: localStorage.getItem("acid"),
          bint_srno: this.state.formData.bint_srno,
          int_noofwheels: this.state.formData.txtNoWheels,
          dec_rate: this.state.formData.txtRate,
        };
        fetchWayBridgeChargeDetail(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            let dataLoadStatus = true,
              rows = this.state.rows,
              rowsCount = rows.length;
            if (res.data.msgType === "success") {
              if (
                res.data.WayBridgeChargeList &&
                res.data.WayBridgeChargeList.length > 0
              ) {
                rows = res.data.WayBridgeChargeList;
                rowsCount = rows.length;
              }
            }
            this.setState(
              {
                dataLoadStatus,
                rows,
                rowsCount,
              },
              () => {
                if (res.data.msgType === "success") {
                  this.clearInfo();
                }
              }
            );
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in SaveWayBridgeChargeMaster.",
              error
            );
          });
      });
    }
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      WayBridgeCharge = row.getValue("int_noofwheels"),
      Rate = row.getValue("dec_rate");
    this.DeleteData(bint_srno, WayBridgeCharge, Rate);
  };

  DeleteData = (bint_srno, WayBridgeCharge) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Way Bridge Charge : " +
              WayBridgeCharge +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteWayBridgeCharge(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteWayBridgeCharge = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteWayBridgeCharge",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      // bol_list: true,
    };
    fetchWayBridgeChargeDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (
            res.data.WayBridgeChargeList &&
            res.data.WayBridgeChargeList.length > 0
          ) {
            rows = res.data.WayBridgeChargeList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtNoWheels").focus();
        }
      })

      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  handleChangeRowsPerPage = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  // handleOnRowDataChange = (rowsOtherDetail) => {
  //   this.setState({
  //     rowsOtherDetail,
  //     rowsCountOtherDetail: rowsOtherDetail.length,
  //   });
  // };
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Way Bridge Charge</b>
          </label>
        </Grid> */}

        <Grid
          container
          direction="column"
          spacing={2}
          // marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              // marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtTxtNum
                  id="txtNoWheels"
                  value={this.state.formData.txtNoWheels}
                  handleOnChange={this.handleOnChange}
                  label="No. Wheels*"
                  width={250}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtRate"}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtRate"
                  value={this.state.formData.txtRate}
                  handleOnChange={this.handleOnChange}
                  label="Rate*"
                  width={250}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SaveWayBridgeCharge}
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveWayBridgeCharge} />
              </Grid>

              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtNoWheels,
                      this.state.formData.txtRate
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          {/* <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            showColumnFilters={false}
            hideColIdList={["bint_srno"]}
            actionColSize={10}
            density={"compact"}
          /> */}
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("WayBridgeCharge")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={20}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(WayBridgeChargeMaster))));
